<div class="row">
  @if (isSuccessfulFormSubmission) {
  <output
    oke-toast
    popover
    aria-live="polite"
    id="transaction-success"
    class="is-success"
    title="Onboard Request"
    body="Your information has been submitted successfully. We will reach out to the ONEOK Contact you listed to discuss the
    next steps in accessing the ONEOK Customer Portal."
    [is-closable]="true"
    (closed)="isSuccessfulFormSubmission=false"
  ></output>
  }
  <h6 class="heading heading--component text--allcaps">
    Customer Portal Access Request Form @if (strapiContent$ | async; as strapiContent) {
    <button type="button" [okePopover]="strapiContent.FormContext">
      <svg-icon [src]="svgIconSrc.info" />
    </button>
    }
  </h6>
</div>
<hr />
<form method="post" id="form-auth" [formGroup]="onboardForm" (ngSubmit)="submitOnboardFormToCreateOnboardRequest()">
  <h4 class="section-heading">Company Information</h4>
  <div class="row mt-4">
    <div class="col m-2">
      <oke-form-input
        view="portal-input"
        formControlName="companyName"
        [label]="'Legal Company Name*'"
        [form]="onboardForm"
      />
      <oke-form-input view="portal-input" formControlName="street1" [label]="'Street 1'" [form]="onboardForm" />
      <oke-form-input view="portal-input" formControlName="street2" [label]="'Street 2'" [form]="onboardForm" />
      <oke-form-input view="portal-input" formControlName="country" [label]="'Country/Region'" [form]="onboardForm" />
    </div>
    <div class="col m-2">
      <oke-form-input view="portal-input" formControlName="city" [label]="'City'" [form]="onboardForm" />
      <oke-form-input view="portal-input" formControlName="state" [label]="'State/Province'" [form]="onboardForm" />
      <oke-form-input view="portal-input" formControlName="postalCode" [label]="'Postal Code'" [form]="onboardForm" />
    </div>
  </div>
  <hr />
  <h4 class="section-heading">User Information</h4>
  <p class="form-description m-4">
    @if (strapiContent$ | async; as strapiContent) {
    <em [innerHTML]="strapiContent.UserInstruction"></em>
    }
  </p>
  <div class="row">
    <div class="col m-2">
      <oke-form-input view="portal-input" formControlName="firstName" [label]="'First Name*'" [form]="onboardForm" />
      <oke-form-input view="portal-input" formControlName="lastName" [label]="'Last Name*'" [form]="onboardForm" />
      <oke-form-input view="portal-input" formControlName="email" [label]="'Email Address*'" [form]="onboardForm" />
      <oke-form-input
        view="portal-input"
        formControlName="oneokContact"
        [label]="'ONEOK Contact*'"
        [form]="onboardForm"
      />
    </div>
    <div class="col m-2">
      <oke-form-input view="portal-input" formControlName="mobile" [label]="'Mobile*'" [form]="onboardForm" />
      <oke-form-input
        view="portal-input"
        formControlName="additionalComments"
        [label]="'Additional Comments'"
        [form]="onboardForm"
      />
      <!-- <div class="form-part mt-4">
        <label class="label input--text__label fw--400">Additional Comments</label>
        <textarea row="1" formControlName="additionalComments"></textarea>
      </div> -->
    </div>
  </div>
  <hr />
  <h4 class="section-heading">Business Segment Selection*</h4>
  <p class="form-description m-4">
    @if (strapiContent$ | async; as strapiContent) {
    <em [innerHTML]="strapiContent.BusinessSegmentInstruction"></em>
    }
  </p>
  <ng-container>
    <div class="container mt-4">
      @if (strapiContent$ | async; as strapiContent) {
      <div class="row">
        @for (segmentCard of segmentSelections; track segmentCard) {
        <div class="col-lg-4 col-md-6 col-sm-12 mt-2">
          <!-- [ngClass] conditional styling description : N/A card will be disabled if any of the other segments are selected OR All business segment cards are disabled if the N/A card is selected  -->
          <a
            id="{{ segmentCard.segment }}"
            class="text-decoration-none segment-card"
            role="button"
            tabindex="0"
            [class]="{ disabled: (selectedSegments.length > 0 && segmentCard.segment === 'N/A' && !selectedSegments.includes('N/A')) || (selectedSegments.length > 0 && selectedSegments.includes('N/A') && segmentCard.segment !== 'N/A') }"
            (click)="businessSegmentSelect($event)"
            (keydown.enter)="businessSegmentSelect($event)"
            (keydown.space)="$event.preventDefault(); businessSegmentSelect($event)"
          >
            @if (segmentCard.segment === 'N/A') {
            <div class="card" [innerHTML]="strapiContent.cards.NotAny + '<p>N/A</p>'"></div>
            } @if (segmentCard.segment === 'NGPIntrastate') {
            <div class="card" [innerHTML]="strapiContent.cards.NgpIntrastate + '<p>NGP Intrastate</p>'"></div>
            } @if (segmentCard.segment === 'NGGP') {
            <div class="card" [innerHTML]="strapiContent.cards.Nggp + '<p>NGGP</p>'"></div>
            }
          </a>
        </div>
        }
      </div>
      }
    </div>
  </ng-container>
  <div class="form-part affordance affordance--primary mt-4">
    <button
      type="submit"
      id="form-btn-submit"
      class="input input--btn"
      style="cursor: pointer"
      [class]="{ disabled: !onboardForm.valid || selectedSegments.length === 0 }"
    >
      <span>Request Access</span>
      <span
        class="spinner-border spinner-border-sm"
        id="loading-spinner"
        role="status"
        [class]="{ 'd-none': !isLoading }"
      ></span>
    </button>
  </div>
</form>
